import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hasGroupPermissions, hasSetPermissions } from '../../utils/roles';
import { ALL_ROLES as allUsers } from '../../constants/userRoles';
import messages from '../../constants/messages';
import Page from './Page';
import Loader from './Loader';


const withRoleRestrictions = (WrappedComponent, roles=allUsers, singleRole = true) => {
  class RoleRestrictionsHOC extends React.Component {
    render() {
      const {
        userRole,
        userRoles,
        error,
        title,
      } = this.props;
      return (
        <Choose>
          <When condition={error}>
            <Page header={title}>
              <div className='text-center'>
                <p className='m-5'>{messages.request.profileError}</p>
              </div>
            </Page>
          </When>
          <When condition={!userRole}>
            <Page header={title}>
              <Loader />
            </Page>
          </When>
          <When condition={singleRole? hasGroupPermissions(userRole, roles) : hasSetPermissions(userRoles, roles)}>
            <WrappedComponent {...this.props} />
          </When>
          <Otherwise>
            <Page>
              <div className='text-center'>
                <p className='m-5'>{messages.common.accessDenied}</p>
              </div>
            </Page>
          </Otherwise>
        </Choose>
      );
    }
  }

  RoleRestrictionsHOC.propTypes = {
    userRole: PropTypes.string,
    userRoles: PropTypes.array,
    error: PropTypes.string,
    title: PropTypes.string
  };

  const mapStateToProps = ({ profile }) => ({
    userRole: profile.role,
    userRoles: profile.roles,
    error: profile.error,
  });

  return(connect(mapStateToProps)(RoleRestrictionsHOC));
};

export default withRoleRestrictions;



// WEBPACK FOOTER //
// src/components/shared/withRoleRestrictions.jsx